module.exports = __webpack_public_path__ + "img/selected_regular_in_maintenance.27c0a453.svg";